// Main game entry point
import { createApp } from 'vue';
import App from './App.vue';

// Create Vue app
const app = createApp(App);
app.mount('#app');

